import React, { useState, useEffect, useRef } from "react";
import useAuth from "../../Auth/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config";
import "./AddTruckDetails.css";
import "../../Pages/HomePage/HomePage.css";
import AlertModal from "../AlertModal/AlertModal";
import axios from "axios";
axios.defaults.baseURL = config.BASE_URL;

const AddTruckDetails = () => {
  const [TruckNumber, setTruckNumber] = useState("");
  const [DONumber, setDONumber] = useState("");
  const [DriverName, setDriverName] = useState(""); // String - selected driver
  const [driverList, setDriverList] = useState([]); // Array - list of drivers from API
  const [Vendor, setVendor] = useState("");
  const [DestinationFrom, setDestinationFrom] = useState("");
  const [DestinationTo, setDestinationTo] = useState("");
  const [TruckType, setTruckType] = useState("");
  const [TransactionStatus, setTransactionStatus] = useState("Open");
  const [Weight, setWeight] = useState("");
  const [Freight, setFreight] = useState("");
  //const [Diesel, setDiesel] = useState('');
  const [DieselAmount, setDieselAmount] = useState("");
  const [DieselSlipNumber, setDieselSlipNumber] = useState("");
  const [TDS_Rate, setTDS_Rate] = useState("");
  const [Advance, setAdvance] = useState("");
  const [Toll, setToll] = useState("");
  const [Adblue, setAdblue] = useState("");
  const [Greasing, setGreasing] = useState("");
  const [vendorsList, setVendorsList] = useState([]);
  const [truckNumbersList, setTruckNumbersList] = useState([]);
  const [destinationList, setDestinationList] = useState([]);

  const [showVendorDropdown, setShowVendorDropdown] = useState(false);
  const [showTruckDropdown, setShowTruckDropdown] = useState(false);
  const [showDestinationFromDropdown, setShowDestinationFromDropdown] =
    useState(false);
  const [showDestinationToDropdown, setShowDestinationToDropdown] =
    useState(false);
  const [showDriverNameDropdown, setShowDriverNameDropdown] = useState(false);

  const [filteredDestinationFrom, setFilteredDestinationFrom] = useState([]);
  const [filteredDestinationTo, setFilteredDestinationTo] = useState([]);
  const [filteredDrivers, setFilteredDrivers] = useState([]);

  const [Rate, setRate] = useState("");

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);

  const {
    username,
    userProfile,
    setTripIDState,
    TripIDState,
    /*truckNumbersList, vendorsList, destinationList,*/ searchValue,
    setSearchValue,
    activeModule,
    setActiveModule,
  } = useAuth();

  let tripID = TripIDState.TripID;

  const location = useLocation();
  const Navigate = useNavigate();

  // Add modal state
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

    // Modal handler functions
  const showModal = (title, message, type = 'info') => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type
    });
  };

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };


  const fetchVendors = async () => {
    try {
      const response = await axios.get("/api/vendors", {
        withCredentials: true,
      });

      setVendorsList(response.data.vendorData);
      console.log(vendorsList);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const fetchTruckNumbers = async () => {
    try {
      const response = await axios.get("/api/trucks", {
        withCredentials: true,
      });

      setTruckNumbersList(response.data.truckData);
      console.log(truckNumbersList);
    } catch (error) {
      console.error("Error fetching truck numbers:", error);
    }
  };

  const fetchDestinationData = async () => {
    try {
      const response = await axios.get("/api/destination", {
        withCredentials: true,
      });

      setDestinationList(response.data.destinationData);
      console.log(destinationList);
    } catch (error) {
      console.error("Error fetching destination data:", error);
    }
  };

  // Consider fetching only active drivers
  const fetchDriverList = async () => {
    try {
      const response = await axios.get("/drivers-list", {
        params: { status: "Active" }, // Filter active drivers only
        withCredentials: true,
      });
      console.log("Driver List:", response.data);
      setDriverList(response.data.resultDrivers);
    } catch (error) {
      console.error("Error fetching driver list:", error);
    }
  };

  // Auto-select driver for driverAssociate profile
  useEffect(() => {
    if (userProfile === "driverAssociate" && username && driverList.length > 0) {
      const currentDriver = driverList.find(driver => 
        driver.username.toLowerCase() === username.toLowerCase()
      );
      if (currentDriver) {
        setDriverName(currentDriver.username);
      }
    }
  }, [driverList, username, userProfile]);

  useEffect(() => {
    // Fetch vendors and truck numbers for dropdowns
    fetchVendors();
    fetchTruckNumbers();
    fetchDestinationData();
    fetchDriverList();
  }, []);

  useEffect(() => {
    sessionStorage.setItem("actMod", "upload");
    setActiveModule(sessionStorage.getItem("actMod"));
  }, []);

  // Update driver filtering effect
  useEffect(() => {
    if (DriverName && driverList.length > 0) {
      const filtered = driverList.filter((driver) =>
        driver.username.toLowerCase().includes(DriverName.toLowerCase()) ||
        (driver.fullName && driver.fullName.toLowerCase().includes(DriverName.toLowerCase()))
      );
      setFilteredDrivers(filtered);
    } else {
      setFilteredDrivers([]);
    }
  }, [DriverName, driverList]);

  useEffect(() => {
    setSearchValue("");

    //let localstorageval = localStorage.getItem('hasInitialized');
    if (location.pathname.startsWith("/home/")) {
      if (TripIDState) {
        console.log(`TripID state from Today's list`, TripIDState);

        setTruckNumber(TripIDState.TruckNumber || "");
        setDONumber(TripIDState.DONumber || 0);
        setDriverName(TripIDState.DriverName || "");
        setVendor(TripIDState.Vendor || "");
        setDestinationFrom(TripIDState.DestinationFrom || "");
        setDestinationTo(TripIDState.DestinationTo || "");
        setTruckType(TripIDState.TruckType || "");
        setTransactionStatus(TripIDState.TransactionStatus || "");
        setWeight(TripIDState.Weight || 0);
        setFreight(TripIDState.Freight ? Math.round(TripIDState.Freight) : 0);
        // setDiesel(TripIDState.Diesel || '');
        setDieselAmount(TripIDState.DieselAmount || 0);
        setDieselSlipNumber(TripIDState.DieselSlipNumber || 0);
        setTDS_Rate(TripIDState.TDS_Rate || 0);
        setAdvance(TripIDState.Advance || 0);
        setToll(TripIDState.Toll || 0);
        setAdblue(TripIDState.Adblue || 0);
        setGreasing(TripIDState.Greasing || 0);
        setRate(TripIDState.Rate || 0);

        // localStorage.setItem('hasInitialized', 'true');
        // localstorageval = localStorage.getItem('hasInitialized');
        // console.log('Local Storage Value:', localstorageval);

        //calculateRate();
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close vendor dropdown if click is outside
      if (showVendorDropdown && !event.target.closest(".da1")) {
        setShowVendorDropdown(false);
      }
      // Close truck dropdown if click is outside
      if (showTruckDropdown && !event.target.closest(".da2")) {
        setShowTruckDropdown(false);
      }
      // Close DestinationFrom dropdown if click is outside
      if (showDestinationFromDropdown && !event.target.closest(".da3")) {
        setShowDestinationFromDropdown(false);
      }
      // Close DestinationTo dropdown if click is outside
      if (showDestinationToDropdown && !event.target.closest(".da4")) {
        setShowDestinationToDropdown(false);
      }
      // Close DriverName dropdown if click is outside
      if (showDriverNameDropdown && !event.target.closest(".da5")) {
        setShowDriverNameDropdown(false);
      }
    };

    if (showDestinationFromDropdown && DestinationFrom && DestinationTo) {
      let filtered = [];
      filtered = destinationList.filter(
        (dest) => dest.to.toLowerCase() === DestinationTo.toLowerCase()
      );

      const uniqueFromLocations = [
        ...new Set(filtered.map((dest) => dest.from.toLowerCase())),
      ].map((from) => ({
        _id: from,
        from: capitalizeFirstLetter(from),
      }));

      setFilteredDestinationFrom(uniqueFromLocations);
    } else if (
      showDestinationFromDropdown &&
      !DestinationFrom &&
      !DestinationTo
    ) {
      const uniqueFromLocations = [
        ...new Set(destinationList.map((dest) => dest.from.toLowerCase())),
      ].map((from) => ({
        _id: from,
        from: capitalizeFirstLetter(from),
      }));

      setFilteredDestinationFrom(uniqueFromLocations);
    } else if (
      showDestinationFromDropdown &&
      !DestinationFrom &&
      DestinationTo
    ) {
      let filtered = [];
      filtered = destinationList.filter(
        (dest) => dest.to.toLowerCase() === DestinationTo.toLowerCase()
      );

      const uniqueFromLocations = [
        ...new Set(filtered.map((dest) => dest.from.toLowerCase())),
      ].map((from) => ({
        _id: from,
        from: capitalizeFirstLetter(from),
      }));

      setFilteredDestinationFrom(uniqueFromLocations);
    }

    if (showDestinationToDropdown && DestinationFrom && DestinationTo) {
      let filtered = [];
      filtered = destinationList.filter(
        (dest) => dest.from.toLowerCase() === DestinationFrom.toLowerCase()
      );

      const uniqueToLocations = [
        ...new Set(filtered.map((dest) => dest.to.toLowerCase())),
      ].map((to) => ({
        _id: to,
        to: capitalizeFirstLetter(to),
      }));

      setFilteredDestinationTo(uniqueToLocations);
    } else if (
      showDestinationToDropdown &&
      !DestinationFrom &&
      !DestinationTo
    ) {
      const uniqueToLocations = [
        ...new Set(destinationList.map((dest) => dest.to.toLowerCase())),
      ].map((to) => ({
        _id: to,
        to: capitalizeFirstLetter(to),
      }));
      setFilteredDestinationTo(uniqueToLocations);
    } else if (showDestinationToDropdown && DestinationFrom && !DestinationTo) {
      let filtered = [];
      filtered = destinationList.filter(
        (dest) => dest.from.toLowerCase() === DestinationFrom.toLowerCase()
      );

      const uniqueToLocations = [
        ...new Set(filtered.map((dest) => dest.to.toLowerCase())),
      ].map((to) => ({
        _id: to,
        to: capitalizeFirstLetter(to),
      }));

      setFilteredDestinationTo(uniqueToLocations);
    }

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    showVendorDropdown,
    showTruckDropdown,
    showDestinationFromDropdown,
    showDestinationToDropdown,
  ]);

  // let [flagFreight, setFlagFreight] = useState(0);
  //let cnt=0;
  const calculateRate = () => {
    const validFrom = destinationList.some(
      (dest) => dest.from.toLowerCase() === DestinationFrom.toLowerCase()
    );

    const validTo = destinationList.some(
      (dest) => dest.to.toLowerCase() === DestinationTo.toLowerCase()
    );

    if (validFrom && validTo) {
      const matchingRoutes = destinationList.filter(
        (destination) =>
          destination.from.toLowerCase() === DestinationFrom.toLowerCase() &&
          destination.to.toLowerCase() === DestinationTo.toLowerCase()
      );

      if (matchingRoutes.length > 0) {
        setRate(matchingRoutes[0].rate);
        if (Weight) {
          setFreight(Math.round(matchingRoutes[0].rate * Weight));
        } else {
          console.log("Setting freight to 0");
          setFreight(0);
        }
      } else if (
        Weight === NaN ||
        Weight === 0 ||
        Weight === undefined ||
        !Weight
      ) {
        console.log("Setting freight to 0");
        setFreight(0);
      }
    } else {
      setRate(0);
      setFreight(0);
    }
  };

  useEffect(() => {
    if (DestinationFrom && DestinationTo && destinationList.length > 0) {
      console.log("Useeffect running");
      calculateRate();
      console.log("Rate val: ", Rate);
    }
  }, [DestinationFrom, DestinationTo, Weight]);

  const getTDS = async () => {
    if (Vendor) {
      // if(TripIDState){
      //   setTDS_Rate(TripIDState.TDS_Rate);
      //   return;
      // }

      // const isVendorNotFocused = inputRef3.current && document.activeElement !== inputRef3.current;
      // const isVendorFocused = inputRef3.current && document.activeElement === inputRef3.current;

      const currentVendor = vendorsList.some(
        (vendor) => vendor.company_name.toLowerCase() === Vendor.toLowerCase()
      );

      if (currentVendor) {
        const getVendor = vendorsList.filter(
          (vendor) => vendor.company_name.toLowerCase() === Vendor.toLowerCase()
        );

        if (getVendor.length > 0) {
          const TDS_Value = getVendor[0].tds_rate;
          setTDS_Rate(TDS_Value);
        }
      } else {
        setTDS_Rate(0);
      }
    }
  };

  useEffect(() => {
    if (Vendor && vendorsList.length > 0) {
      getTDS();
    }
  }, [Vendor]);

  const filteredVendors = vendorsList.filter((vendor) =>
    vendor.company_name.toLowerCase().startsWith(Vendor.toLowerCase())
  );

  const filteredTrucks = truckNumbersList.filter((truck) =>
    truck.truck_no.toLowerCase().includes(TruckNumber.toLowerCase())
  );

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const handleDestinationFrom = (value) => {
    setDestinationFrom(value);
    if (!value) {
      setFilteredDestinationTo([]);
      setFreight(0);
      setRate(0);
      return;
    }
    console.log("Function running");
    console.log("Destination TO : ", DestinationTo);
    let filtered = [];

    if (DestinationTo) {
      // If DestinationTo is already filled, show only matching 'from' locations
      filtered = destinationList.filter(
        (dest) =>
          dest.from.toLowerCase().startsWith(value.toLowerCase()) &&
          dest.to.toLowerCase() === DestinationTo.toLowerCase()
      );
    } else {
      // If DestinationTo is empty, show all matching 'from' locations
      filtered = destinationList.filter((dest) =>
        dest.from.toLowerCase().startsWith(value.toLowerCase())
      );
    }

    const uniqueFromLocations = [
      ...new Set(filtered.map((dest) => dest.from.toLowerCase())),
    ].map((from) => ({
      _id: from,
      from: capitalizeFirstLetter(from),
    }));

    setFilteredDestinationFrom(uniqueFromLocations);
  };

  const handleDestinationTo = (value) => {
    setDestinationTo(value);
    if (!value) {
      setFilteredDestinationFrom([]);
      setFreight(0);
      setRate(0);
      return;
    }

    let filtered = [];

    if (DestinationFrom) {
      // If DestinationFrom is already filled, show only matching 'to' locations
      filtered = destinationList.filter(
        (dest) =>
          dest.to.toLowerCase().startsWith(value.toLowerCase()) &&
          dest.from.toLowerCase() === DestinationFrom.toLowerCase()
      );
    } else {
      // If DestinationFrom is empty, show all matching 'to' locations
      filtered = destinationList.filter((dest) =>
        dest.to.toLowerCase().startsWith(value.toLowerCase())
      );
    }

    const uniqueToLocations = [
      ...new Set(filtered.map((dest) => dest.to.toLowerCase())),
    ].map((to) => ({
      _id: to,
      to: capitalizeFirstLetter(to),
    }));

    setFilteredDestinationTo(uniqueToLocations);
  };

  const handleChangeForm = () => {
    if (userProfile === "unloadingManager") {
      showModal("Access Denied", "You do not have access to this section.", "error");
      setTruckNumber("");
      setDONumber("");
      setDriverName("");
      setVendor("");
      setDestinationFrom("");
      setDestinationTo("");
      setTruckType("");
      setTransactionStatus("");
      setWeight("");
      setFreight("");
      setRate("");
      // setDiesel('');
      setDieselAmount("");
      setDieselSlipNumber("");
      setTDS_Rate("");
      setAdvance("");
      setToll("");
      setAdblue("");
      setGreasing("");
      return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userProfile === "unloadingManager") {
      showModal("Access Denied", "You do not have access to this section.", "error");
      return;
    }

    const validTruckNumber = truckNumbersList.some(
      (truckNumber) =>
        truckNumber.truck_no.toLowerCase() === TruckNumber.toLowerCase()
    );

    if (!validTruckNumber) {
      showModal("Invalid Input", "Please enter valid truck number.", "warning");
      setTruckNumber("");
      return;
    }

    const validVendor = vendorsList.some(
      (vendor) => vendor.company_name.toLowerCase() === Vendor.toLowerCase()
    );

    if (!validVendor) {
      showModal("Invalid Input", "Please enter valid vendor.", "warning");
      setVendor("");
      return;
    }

    const validFrom = destinationList.some(
      (dest) => dest.from.toLowerCase() === DestinationFrom.toLowerCase()
    );
    const validTo = destinationList.some(
      (dest) => dest.to.toLowerCase() === DestinationTo.toLowerCase()
    );

    if (!validFrom) {
      showModal("Invalid Input", "Please enter valid destination.", "warning");
      setDestinationFrom("");
      return;
    }

    if (!validTo) {
      showModal("Invalid Input", "Please enter valid destination.", "warning");
      setDestinationTo("");
      return;
    }

    if (
      !TruckNumber ||
      !Vendor ||
      !DestinationFrom ||
      !DestinationTo ||
      !TruckType ||
      !TransactionStatus
      /*|| !Diesel */
    ) {
      showModal("Incomplete Form", "Please fill the required fields before submitting.", "warning");
      console.log("TruckNumber: ", TruckNumber);
      console.log("Vendor: ", Vendor);
      console.log("DestinationFrom: ", DestinationFrom);
      console.log("DestinationTo: ", DestinationTo);
      console.log("TruckType: ", TruckType);
      console.log("TransactionStatus: ", TransactionStatus);
      return;
    }

    if (
      !TripIDState &&
      (TransactionStatus === "Acknowledged" || TransactionStatus === "Billed")
    ) {
      showModal("Invalid Input", "Cannot set status to Acknowledged or Billed for new trip.", "warning");
      setTransactionStatus("");
      return;
    }

    // Handle form submission logic here
    setTruckNumber("");
    setDONumber("");
    setDriverName("");
    setVendor("");
    setDestinationFrom("");
    setDestinationTo("");
    setTruckType("");
    setTransactionStatus("Open");
    setWeight("");
    setFreight("");
    // setDiesel('');
    setDieselAmount("");
    setDieselSlipNumber("");
    setTDS_Rate("");
    setAdvance("");
    setToll("");
    setAdblue("");
    setGreasing("");

    let sendData = {
      username,
      userProfile,
      TruckNumber,
      DONumber,
      DriverName,
      Vendor,
      DestinationFrom,
      DestinationTo,
      TruckType,
      TransactionStatus,
      Weight,
      Freight,
      Rate,
      /* Diesel */ DieselAmount,
      DieselSlipNumber,
      TDS_Rate,
      Advance,
      Toll,
      Adblue,
      Greasing,
    };

    if (TripIDState) {
      let TripID = TripIDState.TripID;

      let updateData = {
        TripID,
        username,
        userProfile,
        TruckNumber,
        DONumber,
        DriverName,
        Vendor,
        DestinationFrom,
        DestinationTo,
        TruckType,
        TransactionStatus,
        Weight,
        Freight,
        Rate,
        /* Diesel */ DieselAmount,
        DieselSlipNumber,
        TDS_Rate,
        Advance,
        Toll,
        Adblue,
        Greasing,
      };

      try {
        const response = await axios.post("/api/trip", updateData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });

        showModal("Success", response.data.message, "success");
        Navigate("/home");
        setTripIDState("");
        return;
      } catch (error) {
        console.log(error);
        if (error.response.data.message) {
          showModal("Error", error.response.data.message, "error");
        } else {
          showModal("Error", "Error updating the trip details.", "error");
        }
        return;
      }
    }

    try {
      const response = await axios.post("/reports", sendData, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });

      showModal("Success", response.data.message, "success");
    } catch (error) {
      showModal("Error", error.response.data.message, "error");
    }
  };

  return (
    <div className={`add-truck-details-container`}>
      <AlertModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
      />
      <div className="TripInfo">
        <span className="TripStatusLine">{TripIDState && TruckNumber ? "Modification of Trip" : "New Trip Entry"} </span>
        <span className="TripID">Trip ID: </span>
        <span className="TripIDVal">
          {TripIDState && TruckNumber ? tripID : "New"}
        </span>
      </div>
      <div className="form-container">
        <form
          autoComplete="off"
          onChange={handleChangeForm}
          onSubmit={handleSubmit}
          className="add-truck-details-form"
        >
          <div className="form-group da2">
            <label htmlFor="truckNumber">Truck Number:</label>
            <input
              type="text"
              id="truckNumber"
              autoComplete="off"
              value={TruckNumber}
              onChange={(e) => setTruckNumber(e.target.value.toUpperCase())}
              onClick={() => setShowTruckDropdown(true)}
              required
              disabled={userProfile === "unloadingManager"}
            />
            {showTruckDropdown && (
              <ul className="TVdropdown">
                {filteredTrucks.map((truck) => (
                  <li
                    key={truck._id}
                    onClick={() => {
                      setTruckNumber(truck.truck_no);
                      setShowTruckDropdown(false);
                    }}
                    style={{
                      padding: "5px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {truck.truck_no}
                  </li>
                ))}
                {/* {filteredTrucks.length === 0 && (
                <li style={{ padding: '5px' }}>No trucks found</li>
              )} */}
              </ul>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="doNumber">DO Number:</label>
            <input
              type="number"
              step="any"
              id="doNumber"
              value={DONumber}
              onChange={(e) => setDONumber(e.target.value)}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          <div className="form-group da5">
            <label htmlFor="driverName">Driver Name:</label>
            <input
              type="text"
              id="driverName"
              value={DriverName}
              onChange={(e) => {
                setDriverName(e.target.value);
                setShowDriverNameDropdown(true);
              }}
              onClick={() => setShowDriverNameDropdown(true)}
              disabled={userProfile === "unloadingManager"}
            />
            {showDriverNameDropdown && filteredDrivers.length > 0 && (
              <ul className="TVdropdown">
                {filteredDrivers.map((driver) => (
                  <li
                    key={driver._id}
                    onClick={() => {
                      setDriverName(driver.username);
                      setShowDriverNameDropdown(false);
                    }}
                    style={{
                      padding: "5px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {/* <span style={{ fontWeight: "600" }}> */}
                      {driver.username}
                      {/* </span> */}
                    {/* {driver.fullName && (
                      <span style={{ fontSize: "12px", color: "#666" }}>
                        {driver.fullName}
                      </span>
                    )} */}
                  </li>
                ))}
              </ul>
            )}
            {showDriverNameDropdown && filteredDrivers.length === 0 && DriverName && (
              <ul className="TVdropdown">
                <li style={{ padding: "5px", color: "#666" }}>No drivers found</li>
              </ul>
            )}
          </div>
          <div className="form-group da1">
            <label htmlFor="vendors">Vendor:</label>
            <input
              ref={inputRef3}
              type="text"
              id="vendors"
              autoComplete="off"
              value={Vendor}
              onChange={(e) => setVendor(e.target.value)}
              onClick={() => setShowVendorDropdown(true)}
              required
              disabled={userProfile === "unloadingManager"}
            />
            {showVendorDropdown && (
              <ul className="TVdropdown">
                {filteredVendors.map((vendor) => (
                  <li
                    key={vendor._id}
                    onClick={() => {
                      setVendor(vendor.company_name);
                      setShowVendorDropdown(false);
                    }}
                    style={{
                      padding: "5px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {vendor.company_name}
                  </li>
                ))}
                {filteredVendors.length === 0 && (
                  <li style={{ padding: "5px" }}>No vendors found</li>
                )}
              </ul>
            )}
          </div>
          <div className="form-group da3">
            <label htmlFor="destinationFrom">Destination From:</label>
            <input
              ref={inputRef1}
              type="text"
              id="destinationFrom"
              autoComplete="off"
              value={DestinationFrom}
              onChange={(e) => handleDestinationFrom(e.target.value)}
              onClick={() => setShowDestinationFromDropdown(true)}
              required
              disabled={userProfile === "unloadingManager"}
            />
            {showDestinationFromDropdown && (
              <ul className="TVdropdown">
                {filteredDestinationFrom.map((destinationfrom) => (
                  <li
                    key={destinationfrom._id}
                    onClick={() => {
                      handleDestinationFrom(destinationfrom.from);
                      setShowDestinationFromDropdown(false);
                    }}
                    style={{
                      padding: "5px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {destinationfrom.from}
                  </li>
                ))}
                {filteredDestinationFrom.length === 0 && (
                  <li style={{ padding: "5px" }}>No data found</li>
                )}
              </ul>
            )}
          </div>
          <div className="form-group da4">
            <label htmlFor="destinationTo">Destination To:</label>
            <input
              ref={inputRef2}
              className="DestinationToClass"
              type="text"
              id="destinationTo"
              autoComplete="off"
              value={DestinationTo}
              onChange={(e) => handleDestinationTo(e.target.value)}
              onClick={() => setShowDestinationToDropdown(true)}
              required
              disabled={userProfile === "unloadingManager"}
            />
            {showDestinationToDropdown && (
              <ul className="TVdropdown">
                {filteredDestinationTo.map((destinationto) => (
                  <li
                    key={destinationto._id}
                    onClick={() => {
                      handleDestinationTo(destinationto.to);
                      setShowDestinationToDropdown(false);
                    }}
                    style={{
                      padding: "5px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {destinationto.to}
                  </li>
                ))}
                {filteredDestinationTo.length === 0 && (
                  <li style={{ padding: "5px" }}>No data found</li>
                )}
              </ul>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="truckType">Truck Type:</label>
            <select
              id="truckType"
              value={TruckType}
              onChange={(e) => setTruckType(e.target.value)}
              required
              disabled={userProfile === "unloadingManager"}
            >
              <option value="">Select Truck Type</option>
              <option value="Bulker">Bulker</option>
              <option value="Bag">Bag</option>
              <option value="Others">Others</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="transactionStatus">Transaction Status:</label>
            <select
              id="transactionStatus"
              value={TransactionStatus}
              onChange={(e) => setTransactionStatus(e.target.value)}
              required
              disabled={
                userProfile === "unloadingManager" ||
                (location.pathname.startsWith("/home/") ? true : false)
              }
            >
              <option value="Open">Open</option>
              {location.pathname === `/home/${TripIDState.TripID}` && (
                <option value="Acknowledged">Acknowledged</option>
              )}
              {location.pathname === `/home/${TripIDState.TripID}` && (
                <option value="Billed">Billed</option>
              )}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="Weight">Weight (tons):</label>
            <input
              type="number"
              step="any"
              id="Weight"
              value={Weight}
              onChange={(e) => {
                setWeight(e.target.value);
              }}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          {userProfile !== "loadingManager" &&
            userProfile !== "unloadingManager" && (
              <div className="form-group">
                <label htmlFor="Freight">Freight:</label>
                <input
                  type="number"
                  step="any"
                  id="Freight"
                  value={Freight}
                  disabled
                />
              </div>
            )}
          {/* <div className="form-group">
          <label htmlFor="Diesel">Diesel (Ltr):</label>
          <input
            type="text"
            id="Diesel"
            value={Diesel}
            onChange={(e) => setDiesel(e.target.value)}
            required
          />
        </div> */}
          <div className="form-group">
            <label htmlFor="Diesel Amount">Diesel Amount:</label>
            <input
              type="number"
              step="any"
              id="Diesel Amount"
              value={DieselAmount}
              onChange={(e) => setDieselAmount(e.target.value)}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          <div className="form-group">
            <label htmlFor="DieselSlipNumber">Diesel Slip Number:</label>
            <input
              type="number"
              step="any"
              id="DieselSlipNumber"
              value={DieselSlipNumber}
              onChange={(e) => setDieselSlipNumber(e.target.value)}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          <div className="form-group">
            <label htmlFor="TDS_Rate">TDS Rate:</label>
            <input
              type="number"
              step="any"
              id="TDS_Rate"
              value={TDS_Rate}
              onChange={(e) => setTDS_Rate(e.target.value)}
              disabled
            />
          </div>
          <div className="form-group">
            <label htmlFor="Advance">Advance:</label>
            <input
              type="number"
              id="Advance"
              value={Advance}
              onChange={(e) => setAdvance(e.target.value)}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          <div className="form-group">
            <label htmlFor="Toll">Toll:</label>
            <input
              type="number"
              step="any"
              id="Toll"
              value={Toll}
              onChange={(e) => setToll(e.target.value)}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          <div className="form-group">
            <label htmlFor="Adblue">Adblue:</label>
            <input
              type="number"
              step="any"
              id="Adblue"
              value={Adblue}
              onChange={(e) => setAdblue(e.target.value)}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          <div className="form-group">
            <label htmlFor="Greasing">Greasing:</label>
            <input
              type="number"
              step="any"
              id="Greasing"
              value={Greasing}
              onChange={(e) => setGreasing(e.target.value)}
              disabled={userProfile === "unloadingManager"}
            />
          </div>
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddTruckDetails;
